import {
  Box,
  List,
  ListItem,
  ListProps,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import I18n from "i18n";
import React from "react";

type ChangeItem = {
  id: string;
  old: unknown;
  new: unknown;
};

type HistoryChangesProps = ListProps & {
  value?: ChangeItem[];
  id?: string;
  objectName?: string;
  label?: string;
};

const renderValue = (val: unknown): React.ReactNode => {
  if (val === null || val === undefined) return <i>null</i>;
  if (typeof val === "string") {
    try {
      const _val: any = JSON.parse(val);
      if (typeof _val === "object") {
        return (
          <pre style={{ margin: 0, fontSize: 13, fontFamily: "monospace" }}>
            {JSON.stringify(_val, null, 2)}
          </pre>
        );
      }
    } catch {
      //return String(val);
    }

    //return <span style={{ fontFamily: "monospace" }}>{val}</span>;
  }
  if (typeof val === "object") {
    try {
      return (
        <pre style={{ margin: 0, fontSize: 13, fontFamily: "monospace" }}>
          {JSON.stringify(val, null, 2)}
        </pre>
      );
    } catch {
      return String(val);
    }
  }
  return String(val);
};

export const HistoryChanges: React.FC<HistoryChangesProps> = ({
  value,
  objectName,
  ...listProps
}) => {
  if (!value?.length) return null;

  return (
    <List {...listProps} disablePadding>
      {value.map((item, index) => {
        const label = I18n.t(`${objectName}.attributes.${item.id}`) || item.id;

        return (
          <ListItem
            key={item.id + index}
            alignItems="flex-start"
            disableGutters
            sx={{ mb: 2 }}
          >
            <Paper variant="outlined" sx={{ p: 2, width: "100%" }}>
              <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                {label}
              </Typography>

              <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                <Box flex={1}>
                  <Typography variant="body2" color="error" gutterBottom>
                    Régi érték
                  </Typography>
                  {renderValue(item.old)}
                </Box>

                <Box flex={1}>
                  <Typography variant="body2" color="success.main" gutterBottom>
                    Új érték
                  </Typography>
                  {renderValue(item.new)}
                </Box>
              </Stack>
            </Paper>
          </ListItem>
        );
      })}
    </List>
  );
};
